import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CryoTheropy from "../assets/cryotherapy.jpg";

const Banner = ({ videoSrc, title, bannerInfo, buttonText }) => {
  const { i18n } = useTranslation();
  const [isVideoReady, setIsVideoReady] = useState(false);
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);
  const videoRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // 延迟3秒加载视频，减少初始数据传输
    // 对于首屏Banner，用户通常会先看文字内容，延迟加载视频不会影响体验
    const timer = setTimeout(() => {
      setShouldLoadVideo(true);
    }, 3000);

    // Intersection Observer作为备用方案：如果用户快速滚动，确保视频在视口时已开始加载
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 如果元素在视口中，延迟1秒后加载（比定时器更快）
            setTimeout(() => {
              setShouldLoadVideo(true);
            }, 1000);
            observer.disconnect();
          }
        });
      },
      {
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    // 只有当shouldLoadVideo为true时才真正加载视频
    if (shouldLoadVideo && videoRef.current) {
      videoRef.current.load();
    }
  }, [shouldLoadVideo]);

  return (
    <div className="relative h-[90vh] " ref={containerRef}>
      <div className="w-full h-full relative">
        <img
          src={CryoTheropy}
          className={`w-full h-full object-cover transition-opacity duration-500 ${
            isVideoReady ? "opacity-0" : "opacity-100"
          }`}
          alt="Cryo Theropy"
          fetchPriority="high"
          loading="eager"
        />
        {shouldLoadVideo && (
          <video
            ref={videoRef}
            loop
            autoPlay
            muted
            playsInline
            preload="none"
            poster={CryoTheropy}
            className={`w-full h-full object-cover absolute inset-0 transition-opacity duration-500 ${
              isVideoReady ? "opacity-100" : "opacity-0"
            }`}
            onCanPlayThrough={() => {
              setIsVideoReady(true);
            }}
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}
      </div>

      <div className="absolute inset-0 top-0 bg-black opacity-10" />

      <div className="absolute top-0 flex justify-center flex-col z-10 text-white h-full p-5 md:max-w-5xl left-0 font-Merriweather m-auto right-0 text-center">
        <h1
          className={`text-3xl !leading-tight md:text-6xl font-extrabold ${
            i18n.language === "cn" ? "font-poppins" : ""
          }`}
        >
          {title}
        </h1>
        {/* <p className={`mt-10 text-sm  ${i18n.language === 'cn' ? 'font-poppins' : ''}}`}>{bannerInfo}</p> */}
        <button className="w-64 mx-auto h-12 font-bold text-white mt-10 bg-[rgb(161,121,61)] transition-colors duration-300 rounded-md shadow-md hover:shadow-lg">
          <Link
            to="https://www.vagaro.com/artistryspanwellness"
            target="_blank"
          >
            {buttonText}
          </Link>
        </button>
      </div>
    </div>
  );
};

export default Banner;
